/**
 * Promotional Text DTO received from backend
 */
export class PromotionalTextDTO {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public active: boolean,
    public id: number,
    public lastUpdateDate: string,
    public promotionalTextEnglish: string,
    public promotionalTextSpanish: string,
    public promotionalTextPortuguese: string,
    public series: string,
    public familyId: number
  ) {}
}
